import React, { ReactNode } from 'react';
import './AppLayout.scss';

interface IProps {
  children: ReactNode;
}

function AppLayout(props: IProps) {
  return <div className="bg-black">{props.children}</div>;
}

export default AppLayout;
